<template>
  <div class="centered-card">
   <section class="prices">
        <h1 class="pricing yellow">Pricing</h1>
        <p class="subtitle-center"> Get started with the cheapest image <br> generation tool on the market <span class="offer">only 0.018$ per image!</span></p>
        <div class="cards">
           <div class="card-pricing">
              <h1 class="pricing-title green">Subscribe</h1>
              <div class="discount">
              <h2 class="crossed">12.99$</h2><span class="true offer">8.99$</span>
              </div>
              <ul class="pricing-list">
              <li class="list-item">500 prompts</li>
              <li class="list-item">unlimited storage</li>
              <li class="list-item">Email support</li>
              <li class="list-item">Export to PRF/Print</li>
              </ul>
            </div>
            <div class="card-pricing">
              <h1  class="pricing-title blue">Pay Once</h1>
              <div class="discount">
              <h2 class="crossed">8.99$</h2><span class="true offer">5.99$</span>
              </div>
              <ul class="pricing-list">
              <li class="list-item">Get 100 prompts</li>
              <li class="list-item">unlimited storage</li>
              <li class="list-item">Email support</li>
              <li class="list-item">Export to PRF/Print</li>
              </ul>
            </div>
        </div>
        <div class="button-cont">
          <button @click="goToHome" class="home-button">HOME</button>
          <button v-if="user && !user.is_subscribed" @click="goToHome" class="home-button">SUBSCRIBE</button>
        </div>
      </section>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { ref, onMounted } from "vue";

interface User {
is_subscribed: boolean;
id?: string;
name?: string;
email?: string;
}

const router = useRouter();
const userStore = useUserStore();
const user = ref<User | null>(null);

onMounted(async () => {
  try {
      user.value = await userStore.fetchUser();
  } catch (error) {
      console.error('Failed to fetch user:', error);
  }
});

const goToHome = (): void => {
  router.push("/");
}
</script>

<style scoped>
.centered-card {
    background: white;
    max-width: 900px;
    border-radius: 15px;
    padding: 0.2rem 2.5rem 2.5rem 2.5rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    margin: 180px auto;
}

.prices {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    padding-bottom: 2rem;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 2rem;
}

.prices h1 {
    font-size: 2.2rem;
    font-weight: 800;
    margin-bottom: -5px;
}

.cards {
    display: flex;
    gap: 2rem;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 40px;
}

.card-pricing {
    flex: 1 1 300px;
    min-width: 280px;
    max-width: 350px;
    width: 100%;
    padding: 1rem;
    border: 2px solid white;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15), 0 0 0 6px rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    text-align: center;
    box-sizing: border-box;
}

.discount {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0px;
}

.crossed {
    text-decoration: line-through;
    text-align: center;
}

.true {
    text-align: left;
    font-size: 3.2rem;
    font-weight: 800;
}

.offer {
    display: inline-block;
    margin-top: 1px;
    padding: 0 15px 0 5px;
    font-weight: 600;
    transform: rotate(-2deg);
    background: linear-gradient(to bottom, white 50%, #FFAF47 50%);
}

.pricing-list {
    list-style: none;
    padding: 0 0 0 20px;
    text-align: left;
}

.pricing-list li {
    padding: 0.7rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 350;
    color: black;
}

.pricing-list li:last-child {
    border-bottom: none;
}

.pricing-list li::before {
    content: "✔️";
    color: #4CAF50;
    font-weight: bold;
    font-size: 0.8rem;
    margin-right: 0.5rem;
    flex-shrink: 0;
}

.home-button {
    background-color: #578FCA;
    border: 2px solid #578FCA;
    font-size: 0.8rem;
    font-weight: 600;
    color: #323232;
    cursor: pointer;
    padding: 0.6rem 1.2rem;
    border-radius: 10px;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.home-button:hover {
    border-color: #42a8b4;
    background-color: #42a8b4;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

@media (max-width: 768px) {
    .centered-card {
        margin: 20px auto;
        padding: 1rem;
    }

    .cards {
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
        padding-bottom: 20px;
    }

    .card-pricing {
        min-width: 280px;
        max-width: 100%;
        width: 70%;
        margin-bottom: 0;
    }

    .prices h1 {
        font-size: 1.8rem;
    }

    .true {
        font-size: 2.5rem;
    }
}
</style>